import React from "react";
import { publicCountryImage } from "@/lib/countryImage";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import CandidateCard from "@/components/CandidateCard";

export default function CountryDetail() {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data: countries = [] } = useQuery({ queryKey: ["countries"], queryFn: async () => (await api.get("/countries")).data });
  const country = countries.find((c) => c.id === id);
  const { data: candidates = [] } = useQuery({
    queryKey: ["candidates", "country", id],
    queryFn: async () => (await api.get("/candidates", { params: { country_id: id } })).data,
    enabled: !!id,
  });

  if (!country) return <div className="max-w-7xl mx-auto px-6 py-20">{t("common.loading", "Loading…")}</div>;

  return (
    <div>
      <section className="relative h-[60vh] min-h-[420px] flex items-end">
        <img src={publicCountryImage(country)} alt={country.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-16 w-full">
          <div className="overline text-[#d4a017] mb-3">{country.code}</div>
          <h1 className="font-serif text-white text-5xl md:text-7xl tracking-tight">{country.name}</h1>
          <p className="mt-6 text-lg text-zinc-200 max-w-2xl">{country.description}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="flex items-end justify-between mb-10">
          <h2 className="font-serif text-3xl md:text-4xl text-zinc-950">
            {t("country.candidates_for", "Candidates for {{name}}", { name: country.name })}
          </h2>
          <Link to="/catalog" className="text-sm text-[#b8860b]">{t("country.full_catalog", "Full catalog →")}</Link>
        </div>
        {candidates.length === 0 ? (
          <div className="text-zinc-800">{t("country.empty", "No candidates available yet.")}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {candidates.map((c) => (<CandidateCard key={c.id} candidate={c} />))}
          </div>
        )}
      </section>
    </div>
  );
}
